// extracted by mini-css-extract-plugin
module.exports = {"languageSelectContainer":"SetLanguage_languageSelectContainer__31TBg"};